import type { ReactNode } from 'react';

import { isMiniAppLayout } from '@shared/lib/miniAppLayout';

import styles from './Screen.module.css';

/**
 * Route-level semantic and spacing wrapper. App owns route animation so there
 * is exactly one presence lifecycle regardless of which page is mounted.
 */
export function Screen({
  title,
  children,
  variant = 'default',
}: {
  title: string;
  children: ReactNode;
  variant?: 'default' | 'storefront';
}) {
  const miniApp = isMiniAppLayout();

  return (
    <main className={[styles.screen, variant === 'storefront' ? styles.storefront : '', miniApp ? styles.miniApp : ''].filter(Boolean).join(' ')} aria-label={title}>
      {children}
    </main>
  );
}
